import type { ExperienceConfig } from "../types/experience";

export const experienceConfig: ExperienceConfig = {
  recipient: "你",
  intro: {
    title: "今天是一个特别的日子",
    line: "今天，开心最重要。",
    action: "走进星光",
  },
  arrival: {
    title: "HAPPY BIRTHDAY",
    line: "今天的快乐，就从这一刻开始。",
  },
  present: {
    starlight: {
      title: "摘几颗星星，送给今天的你。",
      line: "左右拨开夜空，寻找藏在云后的星光。",
      completeLine: "愿你想摘的星星，都不必等到梦里。",
      action: "去看看花",
    },
    bloom: {
      title: "这朵花归你。",
      line: "借一缕星光，唤醒这一朵。",
      completeLine: "愿你往后的欢喜，也这样一瓣一瓣地展开。",
      action: "唤醒花苞",
      completeAction: "收回花苞，重新染",
      collapseAction: "收回花苞，重新染",
    },
  },
  wish: {
    title: "先许个愿吧。",
    line: "留一个愿望给自己，不用告诉任何人。",
    touchAction: "轻触烛火，许下愿望",
    completeAction: "愿你如愿。",
    blowAction: "吹蜡烛",
    completeLine: "蜡烛熄灭了，看看夜空吧。",
    enableBlowDetection: true,
  },
  finale: {
    title: "Happy Birthday",
    line: "生日快乐！愿你有很多值得开心的小事，也有时间做自己喜欢的事。",
    flowerLine: "花瓣上留着你的颜色。愿新的一岁，也有你喜欢的模样。",
    flowerAction: "再看看这朵花",
    replayAction: "再看一次",
  },
};

export function validateExperienceConfig(config: ExperienceConfig): string[] {
  const errors: string[] = [];
  if (Object.values(config.present).some((scene) =>
    Object.values(scene).some((copy) => copy.trim().length === 0),
  )) {
    errors.push("Every visual scene needs a title, prompt and action.");
  }

  return errors;
}
